import './styles.css'

import cn from 'classnames'
import React from 'react'
import { Tooltip } from 'react-tooltip'

import {
   DATA_FIELD_ERROR_MESSAGE_ATTRIBUTE,
   FIELD_ERROR_MESSAGE_TOOLTIP_ID
} from '../../constants/FieldConstants'
import * as Styles from './styles'

const FieldErrorMessageTooltip = (): React.ReactElement => (
   <Tooltip
      id={FIELD_ERROR_MESSAGE_TOOLTIP_ID}
      place='top'
      opacity={1}
      className={cn(Styles.tooltipStyles)}
      render={({ activeAnchor }) => {
         const errorMessage = activeAnchor?.getAttribute(
            DATA_FIELD_ERROR_MESSAGE_ATTRIBUTE
         )

         if (!errorMessage) return null

         return <p className={Styles.tooltipTitleStyles}>{errorMessage}</p>
      }}
   />
)

export default FieldErrorMessageTooltip
